// Class: starling.display.Stage

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $import = require("./../../import_stub").default;
var $extend = require("./../../extend_stub").default;
function starling_display_DisplayObjectContainer() {return require("./../../starling/display/DisplayObjectContainer");}
function openfl_geom_Rectangle() {return $import(require("openfl/geom/Rectangle"));}
function starling_utils_RectangleUtil() {return require("./../../starling/utils/RectangleUtil");}
function starling_utils_MatrixUtil() {return require("./../../starling/utils/MatrixUtil");}
function openfl__$Vector_Vector_$Impl_$() {return require("./../../openfl/_Vector/Vector_Impl_");}
function js__$Boot_HaxeError() {return require("./../../js/_Boot/HaxeError");}
function openfl_errors_IllegalOperationError() {return $import(require("openfl/errors/IllegalOperationError"));}
function starling_core_Starling() {return require("./../../starling/core/Starling");}
function openfl_geom_Matrix() {return $import(require("openfl/geom/Matrix"));}
function openfl_geom_Matrix3D() {return $import(require("openfl/geom/Matrix3D"));}
function openfl_geom_Point() {return $import(require("openfl/geom/Point"));}
function openfl_geom_Vector3D() {return $import(require("openfl/geom/Vector3D"));}
function starling_events_EnterFrameEvent() {return require("./../../starling/events/EnterFrameEvent");}

// Constructor

var Stage = function(width,height,color) {
	if(color == null) {
		color = 0;
	}
	(starling_display_DisplayObjectContainer().default).call(this);
	this.__width = width;
	this.__height = height;
	this.__color = color;
	this.__fieldOfView = 1.0;
	this.__projectionOffset = new (openfl_geom_Point().default)();
	this.__cameraPosition = new (openfl_geom_Vector3D().default)();
	this.__enterFrameEvent = new (starling_events_EnterFrameEvent().default)("enterFrame",0.0);
	this.__enterFrameListeners = (openfl__$Vector_Vector_$Impl_$().default)._new();
}

// Meta

Stage.__name__ = ["starling","display","Stage"];
Stage.__super__ = (starling_display_DisplayObjectContainer().default);
Stage.prototype = $extend((starling_display_DisplayObjectContainer().default).prototype, {
	advanceTime: function(passedTime) {
		this.__enterFrameEvent.reset("enterFrame",false,passedTime);
		this.broadcastEvent(this.__enterFrameEvent);
	},
	hitTest: function(localPoint) {
		if(!this.get_visible() || !this.get_touchable()) {
			return null;
		}
		if(localPoint.x < 0 || localPoint.x > this.__width || localPoint.y < 0 || localPoint.y > this.__height) {
			return null;
		}
		var target = (starling_display_DisplayObjectContainer().default).prototype.hitTest.call(this,localPoint);
		if(target != null) {
			return target;
		} else {
			return this;
		}
	},
	getStageBounds: function(targetSpace,out) {
		if(out == null) {
			out = new (openfl_geom_Rectangle().default)();
		}
		out.setTo(0,0,this.__width,this.__height);
		this.getTransformationMatrix(targetSpace,Stage.sMatrix);
		return (starling_utils_RectangleUtil().default).getBounds(out,Stage.sMatrix,out);
	},
	getScreenBounds: function(targetSpace,out) {
		var target = this.get_starling();
		if(target == null) {
			return this.getStageBounds(targetSpace,out);
		}
		if(out == null) {
			out = new (openfl_geom_Rectangle().default)();
		}
		var nativeStage = target.get_nativeStage();
		var viewPort = target.get_viewPort();
		var scaleX = this.__width / viewPort.width;
		var scaleY = this.__height / viewPort.height;
		var x = -viewPort.x * scaleX;
		var y = -viewPort.y * scaleY;
		out.setTo(x,y,nativeStage.stageWidth * scaleX,nativeStage.stageHeight * scaleY);
		this.getTransformationMatrix(targetSpace,Stage.sMatrix);
		return (starling_utils_RectangleUtil().default).getBounds(out,Stage.sMatrix,out);
	},
	getCameraPosition: function(space,out) {
		this.getTransformationMatrix3D(space,Stage.sMatrix3D);
		return (starling_utils_MatrixUtil().default).transformCoords3D(Stage.sMatrix3D,this.__width / 2 + this.__projectionOffset.x,this.__height / 2 + this.__projectionOffset.y,-this.get_focalLength(),out);
	},
	addEnterFrameListener: function(listener) {
		var this1 = this.__enterFrameListeners;
		var index = Array.prototype.indexOf.call(this1,listener,0);
		if(index < 0) {
			(openfl__$Vector_Vector_$Impl_$().default).set(this.__enterFrameListeners,this.__enterFrameListeners.length,listener);
		}
	},
	removeEnterFrameListener: function(listener) {
		var this1 = this.__enterFrameListeners;
		var index = Array.prototype.indexOf.call(this1,listener,0);
		if(index >= 0) {
			(openfl__$Vector_Vector_$Impl_$().default).removeAt(this.__enterFrameListeners,index);
		}
	},
	__getChildEventListeners: function(object,eventType,listeners) {
		if(eventType == "enterFrame" && object == this) {
			var length = this.__enterFrameListeners.length;
			var _g1 = 0;
			var _g = length;
			while(_g1 < _g) {
				var i = _g1++;
				(openfl__$Vector_Vector_$Impl_$().default).set(listeners,listeners.length,this.__enterFrameListeners[i]);
			}
		} else {
			(starling_display_DisplayObjectContainer().default).prototype.__getChildEventListeners.call(this,object,eventType,listeners);
		}
	},
	set_width: function(value) {
		throw new (js__$Boot_HaxeError().default)(new (openfl_errors_IllegalOperationError().default)("Cannot set width of stage"));
	},
	set_height: function(value) {
		throw new (js__$Boot_HaxeError().default)(new (openfl_errors_IllegalOperationError().default)("Cannot set height of stage"));
	},
	set_x: function(value) {
		throw new (js__$Boot_HaxeError().default)(new (openfl_errors_IllegalOperationError().default)("Cannot set x-coordinate of stage"));
	},
	set_y: function(value) {
		throw new (js__$Boot_HaxeError().default)(new (openfl_errors_IllegalOperationError().default)("Cannot set y-coordinate of stage"));
	},
	set_scaleX: function(value) {
		throw new (js__$Boot_HaxeError().default)(new (openfl_errors_IllegalOperationError().default)("Cannot scale stage"));
	},
	set_scaleY: function(value) {
		throw new (js__$Boot_HaxeError().default)(new (openfl_errors_IllegalOperationError().default)("Cannot scale stage"));
	},
	set_rotation: function(value) {
		throw new (js__$Boot_HaxeError().default)(new (openfl_errors_IllegalOperationError().default)("Cannot rotate stage"));
	},
	set_skewX: function(value) {
		throw new (js__$Boot_HaxeError().default)(new (openfl_errors_IllegalOperationError().default)("Cannot skew stage"));
	},
	set_skewY: function(value) {
		throw new (js__$Boot_HaxeError().default)(new (openfl_errors_IllegalOperationError().default)("Cannot skew stage"));
	},
	set_filter: function(value) {
		throw new (js__$Boot_HaxeError().default)(new (openfl_errors_IllegalOperationError().default)("Cannot add filter to stage. Add it to 'root' instead!"));
	},
	get_color: function() {
		return this.__color;
	},
	set_color: function(value) {
		if(this.__color != value) {
			this.__color = value;
			this.setRequiresRedraw();
		}
		return value;
	},
	get_stageWidth: function() {
		return this.__width;
	},
	set_stageWidth: function(value) {
		if(this.__width != value) {
			this.__width = value;
			this.setRequiresRedraw();
		}
		return value;
	},
	get_stageHeight: function() {
		return this.__height;
	},
	set_stageHeight: function(value) {
		if(this.__height != value) {
			this.__height = value;
			this.setRequiresRedraw();
		}
		return value;
	},
	get_starling: function() {
		var instances = (starling_core_Starling().default).get_all();
		var numInstances = instances.length;
		var _g1 = 0;
		var _g = numInstances;
		while(_g1 < _g) {
			var i = _g1++;
			if(instances[i].get_stage() == this) {
				return instances[i];
			}
		}
		return null;
	},
	get_focalLength: function() {
		return this.__width / (2 * Math.tan(this.__fieldOfView / 2));
	},
	set_focalLength: function(value) {
		this.__fieldOfView = 2 * Math.atan(this.get_stageWidth() / (2 * value));
		this.setRequiresRedraw();
		return value;
	},
	get_fieldOfView: function() {
		return this.__fieldOfView;
	},
	set_fieldOfView: function(value) {
		this.__fieldOfView = value;
		this.setRequiresRedraw();
		return value;
	},
	get_projectionOffset: function() {
		return this.__projectionOffset;
	},
	set_projectionOffset: function(value) {
		this.__projectionOffset.setTo(value.x,value.y);
		this.setRequiresRedraw();
		return value;
	},
	get_cameraPosition: function() {
		return this.getCameraPosition(null,this.__cameraPosition);
	}
});
Stage.prototype.__class__ = Stage.prototype.constructor = $hxClasses["starling.display.Stage"] = Stage;

// Init

Object.defineProperties(Stage.prototype,{ "color" : { get : function () { return this.get_color (); }, set : function (v) { return this.set_color (v); }}, "stageWidth" : { get : function () { return this.get_stageWidth (); }, set : function (v) { return this.set_stageWidth (v); }}, "stageHeight" : { get : function () { return this.get_stageHeight (); }, set : function (v) { return this.set_stageHeight (v); }}, "starling" : { get : function () { return this.get_starling (); }, set : function (v) { return this.set_starling (v); }}, "focalLength" : { get : function () { return this.get_focalLength (); }, set : function (v) { return this.set_focalLength (v); }}, "fieldOfView" : { get : function () { return this.get_fieldOfView (); }, set : function (v) { return this.set_fieldOfView (v); }}, "projectionOffset" : { get : function () { return this.get_projectionOffset (); }, set : function (v) { return this.set_projectionOffset (v); }}, "cameraPosition" : { get : function () { return this.get_cameraPosition (); }}});

// Statics


Stage.sMatrix = new (openfl_geom_Matrix().default)()
Stage.sMatrix3D = new (openfl_geom_Matrix3D().default)()

// Export

exports.default = Stage;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/starling/display/Stage.js
// module id = 70
// module chunks = 0